/* eslint-disable no-undef */

import { isLocalhost } from "@main/common/utils/index.js";
//set the resource public path dynamically
/* eslint-disable camelcase */
// @ts-expect-error TS MIGRATION ERROR WINDOW OBJECT
__webpack_public_path__ = window.publicPath;
console.warn(
  "%cWarning\n%c%s",
  "font-weight: bold; font-size: 28px; color: red; background-color: yellow;",
  "font-weight: normal; font-size: 20px; color: white",
  // eslint-disable-next-line max-len
  "This is a browser feature intended for developers. Using this console may allow attackers to impersonate you and steal your information using an attack called Self-XSS. Do not enter or paste code that you do not understand."
);

if (isLocalhost) {
  fetch("/id")
    .then((res) => {
      return res.json();
    })
    .then((accountdata) => {
      // @ts-expect-error TS MIGRATION ERROR WINDOW OBJECT
      window.accountDetails = accountdata;
    })
    .catch((error) => {
      console.info("ID api::Error", error);
    })
    .finally(() => {
      import("./bootstrap.tsx");
    });
} else {
  import("./bootstrap.tsx");
}
